// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forecast-table {
  padding-bottom: 2rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.forecast-table__upper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}
.forecast-table__upper__controls {
  display: flex;
  flex-direction: row;
  justify-content: end;
  height: fit-content;
  gap: 0.5rem;
}
.forecast-table__upper__controls__add-button {
  width: fit-content;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.forecast-table__upper__controls__filter-button {
  width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.forecast-table__table {
  height: 65vh;
  overflow-x: auto;
  width: 100%;
  position: relative;
}
.forecast-table__table__header {
  text-transform: uppercase;
  position: sticky;
  top: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: 5vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw;
  place-items: center;
  background-color: #F9FAFB;
  border-radius: 7px;
  height: 15%;
  width: 155vw;
  font-size: 0.8rem;
}
.forecast-table__table__header__cell.sortable-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.forecast-table__table__header__cell.sortable-header:hover {
  color: #4F4BFF;
}
.forecast-table__table__header__cell.sortable-header:hover:not(:has(.pi))::after {
  content: "\\e930";
  font-family: "primeicons";
  font-size: 0.75rem;
  opacity: 0.5;
  margin-left: 0.5rem;
}
.forecast-table__table__header__cell.sortable-header .pi {
  font-size: 0.75rem;
}
.forecast-table__table__body {
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 0.5rem;
}
.forecast-table__table__footer {
  margin-top: 1vh;
  width: 100%;
  display: flex;
  justify-content: end;
}
.forecast-table__table__footer__summary-row {
  width: 80%;
  text-transform: uppercase;
  position: sticky;
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: 18% 19% 19% 19% 19%;
  place-items: center;
  background-color: #F3F2FF;
  border-radius: 7px;
  height: 15%;
  font-size: 0.85rem;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: #4F4BFF;
}

.forecast-table__filter-container {
  position: relative;
}
.forecast-table__filter-container .filters-active {
  background-color: #4F4BFF;
  color: white;
}
.forecast-table__filter-container .filters-active:hover {
  background-color: #3f3ccc;
}
.forecast-table__filters-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #ECECEC;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 999;
  min-width: 250px;
  max-height: 400px;
  overflow-y: auto;
}
.forecast-table__filters-popup__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 6px;
}
.forecast-table__filters-popup__item label {
  cursor: pointer;
  margin-left: 0.25rem;
  color: #1E293B;
  font-size: 0.9rem;
}
.forecast-table__filters-popup__item:hover {
  background: #F8F9FA;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/forecast-table/forecast-table.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAGZ;AAFY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAIhB;AADY;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGhB;AACI;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACR;AAAQ;EACI,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EAEA,4EAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACZ;AACY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAChB;AACgB;EACI,cAAA;AACpB;AAEwB;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAA5B;AAKgB;EACI,kBAAA;AAHpB;AAOQ;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AALZ;AAOQ;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;AALZ;AAMW;EACK,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAJhB;;AAWA;EACI,yBAAA;AARJ;;AAYI;EACI,kBAAA;AATR;AAWQ;EACI,yBAAA;EACA,YAAA;AATZ;AAWY;EACI,yBAAA;AAThB;AAcI;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAZR;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAZZ;AAcY;EACI,eAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;AAZhB;AAeY;EACI,mBAAA;AAbhB","sourcesContent":[".forecast-table{\n    padding-bottom: 2rem;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    &__upper{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n        &__controls{\n            display: flex;\n            flex-direction: row;\n            justify-content: end;\n            height: fit-content;\n            gap: 0.5rem;\n            &__add-button{\n                width: fit-content;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n\n            &__filter-button{\n                width: fit-content;\n                height: 40px;\n                background-color:transparent;\n                color: black;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n        }\n    }\n    &__table{\n        height: 65vh;\n        overflow-x: auto;\n        width: 100%;\n        position: relative;\n        &__header{\n            text-transform: uppercase;\n            position: sticky;\n            top: 0;\n            z-index: 10;\n            display: grid;\n            // grid-template-columns: 5% 15% 15% 15% 15% 15% 15%;\n            grid-template-columns: 5vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw;\n            place-items: center;\n            background-color: #F9FAFB;\n            border-radius: 7px;\n            height: 15%;\n            width: 155vw;\n            font-size: 0.8rem;\n\n            &__cell.sortable-header {\n                display: flex;\n                align-items: center;\n                gap: 0.5rem;\n                cursor: pointer;\n                user-select: none;\n                position: relative;\n                \n                &:hover {\n                    color: #4F4BFF;\n\n                    &:not(:has(.pi)) {\n                        &::after {\n                            content: '\\e930';\n                            font-family: 'primeicons';\n                            font-size: 0.75rem;\n                            opacity: 0.5;\n                            margin-left: 0.5rem;\n                        }\n                    }\n                }\n\n                .pi {\n                    font-size: 0.75rem;\n                }\n            }\n        }\n        &__body{\n            height: calc(100% - 60px);\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            padding-top: 0.5rem;\n        }\n        &__footer{\n            margin-top: 1vh;\n            width: 100%;\n            display: flex;\n            justify-content: end;\n           &__summary-row{\n                width: 80%;\n                text-transform: uppercase;\n                position: sticky;\n                padding: 10px 1rem;\n                display: grid;\n                grid-template-columns: 18% 19% 19% 19% 19%;\n                place-items: center;\n                background-color: #F3F2FF;\n                border-radius: 7px;\n                height: 15%;\n                font-size: 0.85rem;\n           }\n        }\n    }\n    \n}\n\n.p-checkbox.p-highlight .p-checkbox-box{\n    background-color: #4F4BFF ;\n}\n\n.forecast-table {\n    &__filter-container {\n        position: relative;\n        \n        .filters-active {\n            background-color: #4F4BFF;\n            color: white;\n            \n            &:hover {\n                background-color: #3f3ccc;\n            }\n        }\n    }\n\n    &__filters-popup {\n        position: absolute;\n        top: calc(100% + 8px);\n        right: 0;\n        background: white;\n        border: 1px solid #ECECEC;\n        border-radius: 8px;\n        padding: 1.25rem;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n        z-index: 999;\n        min-width: 250px;\n        max-height: 400px;\n        overflow-y: auto;\n\n        &__item {\n            display: flex;\n            align-items: center;\n            gap: 0.75rem;\n            padding: 0.75rem;\n            cursor: pointer;\n            border-radius: 6px;\n\n            label {\n                cursor: pointer;\n                margin-left: 0.25rem;\n                color: #1E293B;\n                font-size: 0.9rem;\n            }\n\n            &:hover {\n                background: #F8F9FA;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
